import Decimal from "decimal.js";
import { DrugScheduleEnum } from "../interfaces/DrugScheduleEnum ";

export const LOCK_TIME = 15; // min
export const LOGOUT_TIME = 24 * 60; // min
export const M_D_YYYY = 'M/d/yyyy';
export const DATE_MIN_STR = '12/31/0001';
export const DATE_MAX_STR = '12/31/9999';
export const UTC = "UTC";
export const MM_DD_YYYY = 'MM/dd/yyyy';
export const MS_IN_A_DAY = 1000 * 60 * 60 * 24;
export const ALL_SCHEDULES = [DrugScheduleEnum.C2, DrugScheduleEnum.C3, DrugScheduleEnum.C4, DrugScheduleEnum.C5, DrugScheduleEnum.MISC, DrugScheduleEnum.Compound];
export const CSV_MIME_TYPE = 'text/csv';
export const PLAIN_TEXT_MIME_TYPE = 'text/plain';
export const XLS_MIME_TYPE = 'application/vnd.ms-excel';
export const XLSX_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const PDF_MIME_TYPE = 'application/pdf';
export const DEFAULT_DATE_FORMAT = 'MMM d a, HH:mm yyyy';
export const NUMBER_MIN_VALUE = new Decimal(0.001).toNumber();
export const WEB_SOCKET_DISCONNECTED_VALUE = 'Disconnected';

